import React from 'react'
import { Row, Column, Button, Colors } from 'react-foundation'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/apps.css')
require('../style/css/custom/icons.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')


const Apps = ({
  toggleVideo_1,
  toggleVideo_2,
  toggleVideo_3
}) => (

<div className="apps" id="apps">


  {
  // PROJECT 1
  }

  {
  // <Row>
  // <h1>Testing a Row + Column</h1>
  //   <Column small={6} large={3}>
  //     <h3>Column 1</h3>
  //   </Column>
  //   <Column small={6} large={3}>
  //     <h3>Column 2</h3>
  //   </Column>
  //   <Column small={6} large={3}>
  //     <h3>Column 3</h3>
  //   </Column>
  //   <Column small={6} large={3}>
  //     <h3>Column 4</h3>
  //   </Column>
  // </Row>
  }


  <Row className=" apps__app"  id="P1_Tsklst">
    {
    // Description, Button and Icons
    }
    <div className="project_header" id="P1_Tsklst_project_header">
      {/*<h6 className="wow fadeIn" data-wow-offset="215">MARCH 2017</h6>*/}
      <h1>TSKLST</h1>

    </div>
    <Column large={5} medium={12} small={12} className="description" data-wow-offset="100" id="P1_Tsklst_description" >

      <div className="description__inner_enclosure" id="P1_Tsklst_description__inner_enclosure">
        <p className="wow fadeIn" data-wow-offset="150">
          <span>
            An interactive to-do checklist for the modern list-maker, designed to offer maximum functionality with minimum effort. Among many thought-out features include full CRUD capability, a variety of dynamic sorting options and contextual filtering, seamlessly integrated into a slick and minimal UI.
          </span>

          <Button color={Colors.PRIMARY} isHollow className="wow animated fadeIn description__code_button" data-wow-offset="200"><a href="https://github.com/soniclouds/TSKLST__beta_1/tree/master/TSKLIST__1">check out the code</a></Button>

        </p>

      </div>

      {
      // still icons (max-width < 1024px)
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="still_icon_iOS" className="still-icon still_icon_iOS" id="stillIcon_Tsklst_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="still_icon_Xcode" className="still-icon still_icon_Xcode" id="stillIcon_Tsklst_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="still_icon_Swift3" className="still-icon still_icon_Swift3" id="stillIcon_Tsklst_Swift3"/>
      {
      // flying icons
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="flying_icon_iOS" className="flying-icon icon_iOS from-left" id="flyingIcon_Tsklst_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="flying_icon_Xcode" className="flying-icon icon_Xcode from-left" id="flyingIcon_Tsklst_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="flying_icon_Swift3" className="flying-icon icon_Swift3 from-left" id="flyingIcon_Tsklst_Swift3"/>

    </Column>

    <Column large={5} medium={12} small={12} className="description" data-wow-offset="100" id="P1_Tsklst_description_2" >

      <div className="description__inner_enclosure" id="P1_Tsklst_description__inner_enclosure_2">
        <p className="wow fadeIn" data-wow-offset="150">
          <span>
            An interactive to-do checklist for the modern list-maker, designed to offer maximum functionality with minimum effort. Among many thought-out features include full CRUD capability, a variety of dynamic sorting options and contextual filtering, seamlessly integrated into a slick and minimal UI.
          </span>

          <Button color={Colors.PRIMARY} isHollow className="wow animated fadeIn description__code_button" data-wow-offset="200"><a href="https://github.com/soniclouds/TSKLST__beta_1/tree/master/TSKLIST__1">check out the code</a></Button>

        </p>

      </div>

      {
      // still icons (max-width < 1024px)
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="still_icon_iOS" className="still-icon still_icon_iOS" id="stillIcon_Tsklst_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="still_icon_Xcode" className="still-icon still_icon_Xcode" id="stillIcon_Tsklst_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="still_icon_Swift3" className="still-icon still_icon_Swift3" id="stillIcon_Tsklst_Swift3"/>
      {
      // flying icons
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="flying_icon_iOS" className="flying-icon icon_iOS from-left" id="flyingIcon_Tsklst_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="flying_icon_Xcode" className="flying-icon icon_Xcode from-left" id="flyingIcon_Tsklst_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="flying_icon_Swift3" className="flying-icon icon_Swift3 from-left" id="flyingIcon_Tsklst_Swift3"/>

    </Column>

    {
    // Video Background and Screenshots
    }
    <Column large={7} medium={12} small={12} className=" images tsklst_images" data-wow-offset="340" >

        <video className="video-background" id="video_1" muted loop  onClick={(event) => toggleVideo_1(event)}>
          <source src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/V_Tsklst__1.mov" type="video/mp4" />
          Your browser does not support the video tag.
        </video>


{
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tsklst_1.png" alt="Tsklst_Screenshot_1" className="xx-small from-right" id="P1_Tsklst_image_1"/>
      //
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tsklst_3.png" alt="Tsklst_Screenshot_3" className=" layer-down from-left-2" id="P1_Tsklst_image_3"/>
      //
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tsklst_4.png" alt="Tsklst_Screenshot_4" className=" layer-down-2 from-left" id="P1_Tsklst_image_4"/>
}
    </Column>


    <Column large={7} medium={12} small={12} className=" images tsklst_images_2" data-wow-offset="340" >

        <video className="video-background" id="video_1" muted loop  onClick={(event) => toggleVideo_1(event)}>
          <source src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/V_Tsklst__1.mov" type="video/mp4" />
          Your browser does not support the video tag.
        </video>


{
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tsklst_1.png" alt="Tsklst_Screenshot_1" className="xx-small from-right" id="P1_Tsklst_image_1"/>
      //
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tsklst_3.png" alt="Tsklst_Screenshot_3" className=" layer-down from-left-2" id="P1_Tsklst_image_3"/>
      //
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tsklst_4.png" alt="Tsklst_Screenshot_4" className=" layer-down-2 from-left" id="P1_Tsklst_image_4"/>
}
    </Column>

  </Row>
  {
  // closes app 1
  }

  {
  // PROJECT 2
  }
  <Row className="apps__app" id="P3_Resist" data-wow-offset="300">
    {
    // Description, Button and Flying Icons
    }
    <div className="project_header" id="P3_Resist_project_header">
      {/*<h6 className="wow fadeIn" data-wow-offset="215">FEBRUARY 2017- PRESENT</h6>*/}
      <h1>RES!ST</h1>
    </div>
    <Column large={5} medium={12} small={12} className="description" id="P3_Resist_description">

      <div className="description__inner_enclosure" id="P3_Resist_description__inner_enclosure">
        <p className="wow fadeIn" data-wow-offset="150">
          <span>
            A full-stack, mobile-first platform for social activism, designed primarily to connect concerned citizens to demonstrations and other activist events. Organizers can add and maintain events — via mobile and web — and users can save “favorites” and connect with each other.
          </span>

          <Button color={Colors.PRIMARY} isHollow className="description__code_button wow fadeIn" data-wow-offset="300"><a href="https://github.com/soniclouds/RESIST__build_1">check out the code</a></Button>

        </p>
      </div>


      {
      // still icons (max-width < 1024px)
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="still_icon_iOS_2" className="still-icon still_icon_iOS_2" id="stillIcon_Resist_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="still_icon_Xcode_2" className="still-icon still_icon_Xcode_2" id="stillIcon_Resist_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="still_icon_Swift3_2" className="still-icon still_icon_Swift3_2" id="stillIcon_Resist_Swift3"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Angular_1.png" alt="still_icon_Angular" className="still-icon still_icon_Angular" id="stillIcon_Resist_Angular"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Express_2.png" alt="still_icon_Express" className="still-icon still_icon_Express" id="stillIcon_Resist_Express"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Node_1.png" alt="still_icon_Node" className="still-icon still_icon_Node" id="stillIcon_Resist_Node"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Mongo_1.png" alt="still_icon_Mongo" className="still-icon still_icon_Mongo" id="stillIcon_Resist_Mongo"/>
      {
      // flying icons
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="flyingIcon_Resist_iOS" className="from-right flying-icon icon_iOS_2 " id="flyingIcon_Resist_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="flyingIcon_Resist_Xcode" className="from-right flying-icon icon_Xcode_2 " id="flyingIcon_Resist_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="flyingIcon_Resist_Swift3" className="from-right flying-icon icon_Swift3_2 " id="flyingIcon_Resist_Swift3"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Angular_1.png" alt="flyingIcon_Resist_Angular" className="from-right flying-icon icon_Angular " id="flyingIcon_Resist_Angular"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Express_2.png" alt="flyingIcon_Resist_Express" className="from-right flying-icon icon_Express " id="flyingIcon_Resist_Express"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Node_1.png" alt="flyingIcon_Resist_Node" className="from-right flying-icon icon_Node " id="flyingIcon_Resist_Node"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Mongo_1.png" alt="flyingIcon_Resist_Mongo" className="from-right flying-icon icon_Mongo " id="flyingIcon_Resist_Mongo"/>


    </Column>


    <Column large={5} medium={12} small={12} className="description" id="P3_Resist_description_2">

      <div className="description__inner_enclosure" id="P3_Resist_description__inner_enclosure_2">
        <p className="wow fadeIn" data-wow-offset="150">
          <span>
            A full-stack, mobile-first platform for social activism, designed primarily to connect concerned citizens to demonstrations and other activist events. Organizers can add and maintain events — via mobile and web — and users can save “favorites” and connect with each other.
          </span>

          <Button color={Colors.PRIMARY} isHollow className="description__code_button wow fadeIn" data-wow-offset="300"><a href="https://github.com/soniclouds/RESIST__build_1">check out the code</a></Button>

        </p>
      </div>


      {
      // still icons (max-width < 1024px)
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="still_icon_iOS_2" className="still-icon still_icon_iOS_2" id="stillIcon_Resist_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="still_icon_Xcode_2" className="still-icon still_icon_Xcode_2" id="stillIcon_Resist_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="still_icon_Swift3_2" className="still-icon still_icon_Swift3_2" id="stillIcon_Resist_Swift3"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Angular_1.png" alt="still_icon_Angular" className="still-icon still_icon_Angular" id="stillIcon_Resist_Angular"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Express_2.png" alt="still_icon_Express" className="still-icon still_icon_Express" id="stillIcon_Resist_Express"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Node_1.png" alt="still_icon_Node" className="still-icon still_icon_Node" id="stillIcon_Resist_Node"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Mongo_1.png" alt="still_icon_Mongo" className="still-icon still_icon_Mongo" id="stillIcon_Resist_Mongo"/>
      {
      // flying icons
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="flyingIcon_Resist_iOS" className="from-right flying-icon icon_iOS_2 " id="flyingIcon_Resist_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="flyingIcon_Resist_Xcode" className="from-right flying-icon icon_Xcode_2 " id="flyingIcon_Resist_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="flyingIcon_Resist_Swift3" className="from-right flying-icon icon_Swift3_2 " id="flyingIcon_Resist_Swift3"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Angular_1.png" alt="flyingIcon_Resist_Angular" className="from-right flying-icon icon_Angular " id="flyingIcon_Resist_Angular"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Express_2.png" alt="flyingIcon_Resist_Express" className="from-right flying-icon icon_Express " id="flyingIcon_Resist_Express"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Node_1.png" alt="flyingIcon_Resist_Node" className="from-right flying-icon icon_Node " id="flyingIcon_Resist_Node"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Mongo_1.png" alt="flyingIcon_Resist_Mongo" className="from-right flying-icon icon_Mongo " id="flyingIcon_Resist_Mongo"/>


    </Column>


    {
    // Video Background and Screenshots
    }
    <Column large={7} medium={12} small={12} className=" images resist_images" data-wow-offset="340">

      <video className="video-background" id="video_2" muted loop onClick={(event) => toggleVideo_2(event)}>
        <source src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/V_Resist__1.mov" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
{
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Resist_1.png" alt="Resist_Screenshot_2" data-wow-offset='200' className="xx-small from-left" id="P3_Resist_image_2"/>
      //
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Resist_2.png" alt="Resist_Screenshot_1" data-wow-offset='200' className="small layer-down-2 from-right" id="P3_Resist_image_1"/>

}
    </Column>

    <Column large={7} medium={12} small={12} className=" images resist_images_2" data-wow-offset="340">

      <video className="video-background" id="video_2" muted loop onClick={(event) => toggleVideo_2(event)}>
        <source src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/V_Resist__1.mov" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
{
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Resist_1.png" alt="Resist_Screenshot_2" data-wow-offset='200' className="xx-small from-left" id="P3_Resist_image_2"/>
      //
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Resist_2.png" alt="Resist_Screenshot_1" data-wow-offset='200' className="small layer-down-2 from-right" id="P3_Resist_image_1"/>

}
    </Column>

  </Row>
  {
  // closes app 2
  }

  {
  // PROJECT 3
  }
  <Row className="apps__app" id="P2_Tipro" data-wow-offset="300">
    {
    // Description, Button and Flying Icons
    }
    <div className="project_header" id="P2_Tipro_project_header">
      {/*<h6 className="wow fadeIn" data-wow-offset="215">MARCH 2017</h6>*/}
      <h1>TIPRO</h1>
    </div>
    <Column large={5} medium={12} small={12} className="description" id="P2_Tipro_description">

      <div className="description__inner_enclosure" id="P2_Tipro_description__inner_enclosure">
        <p className="wow fadeIn" data-wow-offset="150">
          <span>
            Designed to be as effortless and intuitive as possible, this is the perfect tip calculator for the modern individual. Simply flick or tap different areas of the screen to perform any tip calculation, without ever typing a digit. Just flick, tap, and repeat.
          </span>

          <Button color={Colors.PRIMARY} isHollow className="description__code_button wow fadeIn" data-wow-offset="300"><a href="https://github.com/soniclouds/TIPRO__beta_1">check out the code</a></Button>

        </p>
      </div>


      {
      // still icons (max-width < 1024px)
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="still_icon_iOS" className="still-icon still_icon_iOS" id="stillIcon_Tipro_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="still_icon_Xcode" className="still-icon still_icon_Xcode" id="stillIcon_Tipro_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="still_icon_Swift3" className="still-icon still_icon_Swift3" id="stillIcon_Tipro_Swift3"/>
      {
      // flying icons
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="flyingIcon_Tipro_iOS" className="flying-icon icon_iOS from-left" id="flyingIcon_Tipro_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="flyingIcon_Tipro_Xcode" className="flying-icon icon_Xcode from-left" id="flyingIcon_Tipro_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="flyingIcon_Tipro_Swift3" className="flying-icon icon_Swift3 from-left" id="flyingIcon_Tipro_Swift3"/>

    </Column>


    <Column large={5} medium={12} small={12} className="description" id="P2_Tipro_description_2">

      <div className="description__inner_enclosure" id="P2_Tipro_description__inner_enclosure_2">
        <p className="wow fadeIn" data-wow-offset="150">
          <span>
            Designed to be as effortless and intuitive as possible, this is the perfect tip calculator for the modern individual. Simply flick or tap different areas of the screen to perform any tip calculation, without ever typing a digit. Just flick, tap, and repeat.
          </span>

          <Button color={Colors.PRIMARY} isHollow className="description__code_button wow fadeIn" data-wow-offset="300"><a href="https://github.com/soniclouds/TIPRO__beta_1">check out the code</a></Button>

        </p>
      </div>


      {
      // still icons (max-width < 1024px)
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="still_icon_iOS" className="still-icon still_icon_iOS" id="stillIcon_Tipro_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="still_icon_Xcode" className="still-icon still_icon_Xcode" id="stillIcon_Tipro_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="still_icon_Swift3" className="still-icon still_icon_Swift3" id="stillIcon_Tipro_Swift3"/>
      {
      // flying icons
      }
      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/iOS_1.png" alt="flyingIcon_Tipro_iOS" className="flying-icon icon_iOS from-left" id="flyingIcon_Tipro_iOS"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Xcode_1.png" alt="flyingIcon_Tipro_Xcode" className="flying-icon icon_Xcode from-left" id="flyingIcon_Tipro_Xcode"/>

      <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Swift3_1.png" alt="flyingIcon_Tipro_Swift3" className="flying-icon icon_Swift3 from-left" id="flyingIcon_Tipro_Swift3"/>

    </Column>


    {
    // Video Background and Screenshots
    }
    <Column large={7} medium={12} small={12} className=" images tipro_images" data-wow-offset="340">

      <video className="video-background" id="video_3" muted loop onClick={(event) => toggleVideo_3(event)}>
        <source src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/V_Tipro__1.mov" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
{
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tipro_2.png" alt="Tipro_Screenshot_2" data-wow-offset='200' className="from-right" id="P2_Tipro_image_2"/>
      //
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tipro_1.png" alt="Tipro_Screenshot_1" data-wow-offset='200' className="xx-small layer-down from-left" id="P2_Tipro_image_1"/>
}

    </Column>

    <Column large={7} medium={12} small={12} className=" images tipro_images_2" data-wow-offset="340">

      <video className="video-background" id="video_3" muted loop onClick={(event) => toggleVideo_3(event)}>
        <source src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/V_Tipro__1.mov" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
{
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tipro_2.png" alt="Tipro_Screenshot_2" data-wow-offset='200' className="from-right" id="P2_Tipro_image_2"/>
      //
      // <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Projects/SS_Tipro_1.png" alt="Tipro_Screenshot_1" data-wow-offset='200' className="xx-small layer-down from-left" id="P2_Tipro_image_1"/>
}

    </Column>

  </Row>
  {
  // closes app 3
  }


</div>

// closes 'apps'


)

//   }
//
// })

export default Apps



// WEBPACK FOOTER //
// ./src/components/apps.js